import React, { useEffect, useRef, useState } from 'react';
import { get, patch } from '../../../services/apiController';
import { DEBOUNCE_DELAY, TABLE_DEFAULT_LIMIT } from '../../../util/constant';
import { FloatingLabel, Form, Table, Button } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../../Pagination';
import Breadcrumb from '../../../components/Breadcrumb';
import Factory from '../../../components/factory';
import useDebounce from '../../useDebounce';
import moment from 'moment';
import { GrDocumentExcel, GrDocumentPdf } from 'react-icons/gr';
import { FiSave } from 'react-icons/fi';
import Kitchen from '../../../components/Kitchen';
import { EditIcon } from '../../icons';
import KitchenUpdateModal from './KitchenUpdateModal';
import Item from '../../../components/item';
import { FaQrcode } from 'react-icons/fa';
import QRCode from 'react-qr-code';
import { formatDate, QrCodeDownload } from '../../../util/helper';

const DeliveryChallanList = ({ type, title }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [indentList, setIndentList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [factories, setFactories] = useState([]);
  const [state, setState] = useState({
    dateFrom: moment().format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    factoryId: 116,
    kitchenId: '',
  });
  const [appliedState, setAppliedState] = useState({
    dateFrom: moment().format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    factoryId: 116,
    kitchenId: '',
  });
  const clickToDownload = useRef(null);

  const [updateKitchenModal, setUpdateKitchenModal] = useState(false);
  const [updateKitchenProp, setUpdateKitchenProp] = useState({
    indentId: '',
    factoryId: '',
    kitchenId: '',
    itemId: '',
  });

  function getIndents(download = false) {
    try {
      let url = `/inv/production-indent/?&dateFrom=${appliedState.dateFrom}&dateTo=${appliedState.dateTo}&kitchenId=${
        appliedState.kitchenId
      }&isPMProductionIndent=true&type=${type}&itemId=${appliedState.itemId ?? ''}`;
      if (download) {
        url += `&download=${download}`;
      } else {
        url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
      }
      get(url).then((response) => {
        if (download) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setIndentList(response.data.rows);
          setTotalRecords(response.data.count ?? 0);
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  function getFactories() {
    try {
      get(`/branches/?type=factory`).then((response) => {
        setFactories(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  const handleEditKitchen = (productionIndentId, factoryId, kitchenId) => {
    setUpdateKitchenProp({
      productionIndentId,
      factoryId,
      kitchenId,
    });
    setUpdateKitchenModal(true);
  };

  const handleApplyFilter = () => {
    setAppliedState({ ...state });
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    getIndents();
  }, [currentPage, appliedState]);

  useEffect(() => {
    getFactories();
  }, []);

  const handleSubmit = (productionIndentId, index) => {
    patch(
      { vehicleNumber: indentList[index]?.vehicleNumber, eWayBillNumber: indentList[index]?.eWayBillNumber },
      `/inv/pm-production-indent/delivery-challan/${productionIndentId}`
    )
      .then((res) => {
        toast.success(res.data.message);
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message) || 'Something went wrong');
  };

  const getPmDcUrl = (itemId) => {
    return window.location.origin + `/#/inv/pm-delivery-challan/${itemId}`;
  };

  const downloadQrCode = (e, item) => {
    e.preventDefault();
    QrCodeDownload(
      `pm-dc-qr-code${item.id}`,
      item?.productionIndentNumber,
      item?.isPackagingKitchen ? item?.Kitchen?.name : `KANTI SWEETS - ${item?.Kitchen?.name}`
    );
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Inventory Managment' },
          { link: '#', title },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            {title} | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <div style={{ marginRight: '20px' }}>
              <Kitchen
                query={`factoryId=116&type=${type}`}
                kitchenId={state.kitchenId}
                onChange={(kitchenId) => setState({ ...state, kitchenId })}
                name={'kitchenId'}
                isDisabled={state.factoryId === ''}
                label={type === 'JW' ? 'Select Vendor' : 'Select Location'}
              />
            </div>
            {type === 'JW' && (
              <div style={{ marginRight: '20px' }}>
                <Item
                  itemId={state.itemId}
                  name="itemId"
                  onChange={(itemId) => {
                    setState({ ...state, itemId });
                  }}
                  query={type === 'JW' ? 'type=JW' : ''}
                  // type={type}
                />
              </div>
            )}
            <FloatingLabel style={{ marginRight: '20px' }} controlId="floatingInput" label="Start Date">
              <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
            </FloatingLabel>
            <FloatingLabel style={{ marginRight: '20px' }} controlId="floatingInput" label="End Date">
              <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
            </FloatingLabel>
            <FloatingLabel label="Factory">
              <Factory
                factoryId={state.factoryId}
                onChange={(e) => setState({ ...state, factoryId: e.target.value })}
                factories={factories}
                label="factory"
                name="factoryId"
                disabled
              />
            </FloatingLabel>
            <Button type="button" className="btn app-btn-default dark-color me-2 mx-3" onClick={handleApplyFilter}>
              Apply
            </Button>
          </div>
          <div style={{ alignItems: 'center' }}>
            <GrDocumentExcel
              title="Download Excel"
              className="react-icons green"
              style={{ width: '30px', height: '30px', cursor: 'pointer' }}
              onClick={() => getIndents(true)}
            />
            <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
          </div>
        </div>
        <div className="btn-wrapper ">
          {totalRecords === 0 && (
            <div className="container d-flex align-items-center justify-content-center">
              <h5 className="text-danger">No Records Found</h5>
            </div>
          )}
        </div>

        {totalRecords > 0 && (
          <div className="card-body px-0 rowspan-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped bordered>
                  <thead>
                    <tr className="text-center">
                      <th>#</th>
                      <th>DC Number</th>
                      <th>DC Date</th>
                      <th>Created Date</th>
                      <th>Factory</th>
                      <th>Location</th>
                      <th>Created By</th>
                      <th>E-Way Bill Number</th>
                      <th>Vehicle Number</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {indentList.map((item, index) => {
                      const dcDate = formatDate(item?.productionIndentDate);
                      let dcNumber = item?.productionIndentNumber;
                      if (dcNumber && !dcNumber.includes('/2024/116')) {
                        const parts = dcNumber.split('/');
                        dcNumber = 'MRSGWN/' + parts[2] + (parts.includes('JW') ? '/' + parts[3] : '');
                      }

                      return (
                        <tr role="row" className="text-center" key={item?.id}>
                          <td style={{ verticalAlign: 'top' }}>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          <td>{dcNumber}</td>
                          <td>{dcDate}</td>
                          <td>{formatDate(item?.createdAt, true)}</td>
                          <td>{item?.Branch?.name}</td>
                          <td>
                            {item?.Kitchen?.name} {'  '}
                            <EditIcon
                              onClick={() => handleEditKitchen(item?.id, item?.factoryId, item?.kitchenId)}
                              style={{ color: 'teal', cursor: 'pointer' }}
                            />
                          </td>
                          <td>{item?.User?.name}</td>
                          <td>
                            <input
                              value={item.eWayBillNumber ?? ''}
                              name="eWayBillNumber"
                              onChange={(e) => {
                                const newList = [...indentList];
                                newList[index].eWayBillNumber = e.target.value;
                                setIndentList(newList);
                              }}
                              type="text"
                              placeholder="Bill Number"
                            />
                          </td>
                          <td>
                            <input
                              value={item.vehicleNumber ?? ''}
                              name="vehicleNumber"
                              onChange={(e) => {
                                const newList = [...indentList];
                                newList[index].vehicleNumber = e.target.value;
                                setIndentList(newList);
                              }}
                              type="text"
                              placeholder="Vehicle Number"
                            />
                          </td>
                          <td className="actions">
                            <FiSave
                              className="react-icons green"
                              title="Update Delivery Challan"
                              style={{ cursor: 'pointer', height: '20px', width: '20px', marginRight: '5px' }}
                              onClick={() => handleSubmit(item?.id, index)}
                            />
                            <a href={`#/inv/pm-delivery-challan/${item.id}`} target="_blank" rel="noreferrer">
                              <GrDocumentPdf
                                className="react-icons red"
                                title="View Challan"
                                style={{ cursor: 'pointer', height: '15px', width: '15px' }}
                              />
                            </a>
                            <a href="/" onClick={(e) => downloadQrCode(e, item)} title="Download QR Code">
                              <FaQrcode />
                            </a>
                            <div style={{ display: 'none' }}>
                              <QRCode
                                id={`pm-dc-qr-code${item.id}`}
                                value={getPmDcUrl(item.id)}
                                size={100}
                                level="H"
                                style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <PaginationInPage
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={totalRecords}
                  TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {updateKitchenModal && (
        <KitchenUpdateModal
          view={updateKitchenModal}
          setView={setUpdateKitchenModal}
          factoryId={updateKitchenProp.factoryId}
          kitchenId={updateKitchenProp.kitchenId}
          productionIndentId={updateKitchenProp.productionIndentId}
          callback={() => getIndents()}
          label="Update Location"
          type={type}
        />
      )}
    </React.Fragment>
  );
};

export default DeliveryChallanList;
